import { useKeycloak } from '@react-keycloak/web';
import Keycloak, { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';
import jwtDecode from 'jwt-decode';

type KeycloakInstance = ReturnType<typeof useKeycloak>['keycloak'];

interface IDTokenResult {
  idToken?: string;
  error?: string;
}

interface TokenResult {
  // Choose a descriptive name
  accessToken?: string;
  error?: string;
}

interface DecodedToken {
  email?: string;
}

export class ApteanSSOProvider {
  /*private static keycloakInstance: KeycloakInstance | null = null;*/

  static createKeycloakInstance(): KeycloakInstance {
    return new Keycloak(ApteanSSOProvider.getConfigurations());
  }

  static async getAccessToken(): Promise<TokenResult> {
    try {
      const keycloak = ApteanSSOProvider.getKeycloakInstance();

      if (!keycloak.authenticated) {
        return { error: 'Keycloak is not initialized' };
      }

      return { accessToken: keycloak.token };
    } catch (error) {
      return { error: error as string };
    }
  }

  static async getDecodedToken(): Promise<DecodedToken | null> {
    try {
      const result = await ApteanSSOProvider.getIDToken();
      if (result.idToken) {
        return jwtDecode(result.idToken);
      }
      return null;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  static getKeycloakInstance(): KeycloakInstance {
    const instance = useKeycloak();
    return instance.keycloak;
  }

  static async getIDToken(): Promise<IDTokenResult> {
    try {
      const keycloak = ApteanSSOProvider.getKeycloakInstance();

      if (!keycloak.authenticated) {
        throw new Error('Keycloak is not initialized');
      }

      return { idToken: keycloak.idToken };
    } catch (error) {
      // Assuming error is a string, adjust the error type if needed
      return { error: error as string };
    }
  }

  static getInitConfigurations(): KeycloakInitOptions {
    return {
      onLoad: 'login-required',
      redirectUri: window.location.origin,
      scope: process.env.REACT_APP_ApteanIAM_Scope ? process.env.REACT_APP_ApteanIAM_Scope : '',
    };
  }

  private static getConfigurations(): KeycloakConfig {
    return {
      url: process.env.REACT_APP_ApteanIAM_AuthServerUrl ? process.env.REACT_APP_ApteanIAM_AuthServerUrl : '',
      realm: process.env.REACT_APP_ApteanIAM_Realm ? process.env.REACT_APP_ApteanIAM_Realm : '',
      clientId: process.env.REACT_APP_ApteanIAM_ClientId ? process.env.REACT_APP_ApteanIAM_ClientId : '',
    };
  }
}
